// ABOUTME: Plain-text rendering of the stored values of a bulk change row or action: strings, measures and link ids.
// ABOUTME: Shared by the recap sentences and the before → after cell of the preview.

import { dateToString } from '@src/components/formFields/dateToString';
import dayjs from 'dayjs';

/** The node id of a link / media value: a bare id, or an object carrying `id`. */
export const linkIdOf = (item: unknown): string =>
    item && typeof item === 'object' && 'id' in item
        ? String((item as { id: unknown }).id)
        : String(item);

/** One stored value as text: `{ value, measure }` reads "12 kg". */
export function storedValueText(item: unknown): string {
    if (item === null || item === undefined) return '';
    if (typeof item === 'object') {
        const record = item as Record<string, unknown>;
        if ('value' in record) {
            return [record.value, record.measure].filter(part => part).join(' ');
        }
        if ('id' in record) return String(record.id);
        return JSON.stringify(item);
    }
    return String(item);
}

/** A stored date ("2027-1-15", as the node editor writes it) as a date input value ("2027-01-15"). */
export function toDateInputValue(stored: string): string {
    const [year, month, day] = stored.split('-');
    if (!year || !month || !day) return '';
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

/** A date input value ("2027-01-15") in the stored format of the node editor ("2027-1-15"). */
export function fromDateInputValue(input: string): string {
    const date = input ? dayjs(input) : null;
    return date?.isValid() ? dateToString(date) : '';
}
